import { render, staticRenderFns } from "./OrderProductTable.vue?vue&type=template&id=19d62c12"
import script from "./OrderProductTable.vue?vue&type=script&lang=js"
export * from "./OrderProductTable.vue?vue&type=script&lang=js"
import style0 from "./OrderProductTable.vue?vue&type=style&index=0&id=19d62c12&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports